<template>
  <div
    class="my-healthy-course-main"
    v-if="myHealthyCourse"
    @click="clickCourseInfo()"
  >
    <div class="my-healthy-course-container show-flex-box-r">
      <dl class="show-flex-box-c">
        <dd class="show-flex-box-r">
          <span>
            <img :src="myHealthyCourse.logo_url && myHealthyCourse.logo_url.o" >
            <em v-if="!!myHealthyCourse.is_vip_course"></em>
            <h3
              class="show-flex-box-r show-flex-center"
              v-if="myHealthyCourse.course_section_num > 0">
              <span>{{ myHealthyCourse.course_section_num }}节课</span>
            </h3>
          </span>
          <div class="course-message show-flex-box-r">
            <h3 class="show-flex-box-c">
              <!-- 正常的课程 右边栏 start -->
              <dl class="show-flex-box-c right-normal-course" v-if="!isProgressCourse">
                <dt class="show-flex-box-c">
                  <strong class="title-box show-flex-box-r">
                    <strong class="hide-line1">
                      {{ myHealthyCourse.title }}
                    </strong>
                  </strong>
                  <div class="lecture-info-bar show-flex-box-r">
                    <div class="show-flex-box-r" v-if="myHealthyCourse.speakerInfo">
                      <span>
                        <img :src="myHealthyCourse.speakerInfo.avatarUrl" >
                      </span>
                      <strong class="show-flex-box-r">
                        <span class="hide-line1">{{ myHealthyCourse.speakerInfo.name }}</span>
                        <span class="hide-line1" v-if="myHealthyCourse.speakerInfo.field">{{ dealShowLectureField(myHealthyCourse.speakerInfo.field) }}</span>
                      </strong>
                    </div>
                  </div>
                </dt>
                <dd class="show-flex-box-r b-bottom">
                  <h3 class="show-flex-box-r">
                    <strong class="hide-line1">
                      {{myHealthyCourse.apply_num}}人已学习
                    </strong>
                  </h3>
                  <h4
                    class="show-flex-box-r show-flex-center" 
                    v-if="!!myHealthyCourse.is_vip_course && !myHealthyCourse.is_free">
                    <span>{{ dealShowVipCoursePrice(myHealthyCourse.vip_price) }}</span>
                  </h4>
                  <h2 :class="{'show-flex-box-r': true, 'is-vip-course-and-not-free': myHealthyCourse.is_vip_course && !myHealthyCourse.is_free && isVip}">
                    <strong>{{ dealShowCoursePrice(myHealthyCourse.is_free) }}</strong>
                  </h2>
                </dd>
              </dl>
              <!-- 正常的课程 右边栏 end -->

              <!-- 学习进度的课程 右边栏 start -->
              <dl class="show-flex-box-c right-progress-course" v-if="isProgressCourse">
                <dt class="show-flex-box-c">
                  <strong class="title-box show-flex-box-r">
                    <strong class="hide-line1">
                      {{ myHealthyCourse.title }}
                    </strong>
                  </strong>
                  <div class="learn-progress-bar show-flex-box-c">
                    <div class="show-flex-box-r">
                      <!-- 进度条 start -->
                      <div class="progress-bar-container">
                        <div
                          class="progress-bar-content"
                          :style="`width: ${myHealthyCourse.progress}%`"
                        ></div>
                      </div>
                      <!-- 进度条 start -->
                      <h3 class="show-flex-box-r">
                        <strong>{{ dealShowLearnProgressInfo(myHealthyCourse.progress) }}</strong>
                        <span v-if="myHealthyCourse.progress > 0 && myHealthyCourse.progress < 100">{{ myHealthyCourse.progress }}%</span>
                      </h3>
                    </div>
                  </div>
                </dt>
                <dd class="show-flex-box-r b-bottom">
                  <strong class="hide-line1">
                    {{myHealthyCourse.apply_num}}人已学习
                  </strong>
                </dd>
              </dl>
              <!-- 学习进度的课程 右边栏 end -->
            </h3>
          </div>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    myHealthyCourseData: [Object],
    isProgressCourse: {
      type: [Boolean],
      default: false
    },
    isVip: {
      type: [Boolean],
      default: false
    }
  },
  data() {
    return {
      myHealthyCourse: null,
    };
  },
  watch: {
    myHealthyCourseData: function () {
      this.configData();
    },
  },
  mounted() {
    this.configData();
  },
  methods: {
    configData: function () {
      if (!this.myHealthyCourseData) {
        return ;
      }

      this.myHealthyCourse = this.myHealthyCourseData;
    },
    dealShowLectureField(field){
      return ` | ${field}`;
    },
    dealShowVipCoursePrice(vipPrice){
      let showMsg = 'VIP ';
      if(vipPrice > 0){
        showMsg = showMsg + '¥' + vipPrice;
      } else {
        showMsg = showMsg + '免费';
      }

      return showMsg;
    },
    dealShowCoursePrice: function(isFree){
      if (isFree) {
        return '免费';
      }else {
        return `¥${this.myHealthyCourse.price}`;
      }
    },
    // 处理进度栏的显示字
    dealShowLearnProgressInfo(progress){
      let showMsg = '';
      if(progress == 0){
        showMsg = '未开始学习';
      } else if (progress < 100) {
        showMsg = '学习进度 ';
      } else {
        showMsg = '已完成学习';
      }

      return showMsg;
    },
    clickCourseInfo() {
      this.$emit('clickInfo', {
        id: this.myHealthyCourse.id
      });
    },

  },
};
</script>

<style lang="less">
.my-healthy-course-main {
  width: 100%;
  // height: 100%;
  background: #ffffff;
  > .my-healthy-course-container {
    width: 100%;
    // height: 100%;
    > dl {
      width: 100%;
      // height: 100%;
      > dd {
        width: 100%;
        > span {
          position: relative;
          width: 1.28rem;
          height: 0.96rem;
          flex-shrink: 0;
          border-radius: 0.08rem;
          overflow: hidden;
          > img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          > em {
            position: absolute;
            top: 0rem;
            left: 0rem;
            flex-shrink: 0;
            display: block;
            width: 0.28rem;
            height: 0.14rem;
            background: url('../../assets/course/vip_course_icon.png') center center no-repeat;
            background-size: 100% 100%;
          }
          > h3{
            position: absolute;
            // right: 0.04rem;
            left: 0.04rem;
            bottom: 0.04rem;
            flex-shrink: 0;
            width: 0.56rem;
            height: 0.22rem;
            background: rgba(0, 0, 0, 0.5);
            border-radius: 0.04rem;
            > span{
              font-size: 0.12rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 0.17rem;
            }
          }
        }
        > .course-message {
          width: 0;
          flex-grow: 1;
          padding-left: 0.16rem;
          // height: 0.84rem;
          // overflow: hidden;
          > h3 {
            width: 100%;
            height: 1.04rem;
            // height: 100%;
            > .right-normal-course {
              width: 100%;
              height: 100%;
              justify-content: space-between;
              > dt {
                width: 100%;
                > .title-box {
                  width: 100%;
                  padding-top: 0.04rem;
                  padding-bottom: 0.15rem;
                  > strong {
                    width: 100%;
                    font-size: 0.15rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    line-height: 0.21rem;
                  }
                }
                > .lecture-info-bar{
                  flex-shrink: 0;
                  width: 100%;
                  height: 0.2rem;
                  > div{
                    width: 100%;
                    align-items: center;
                    > span{
                      flex-shrink: 0;
                      width: 0.2rem;
                      height: 0.2rem;
                      margin-right: 0.04rem;
                      border-radius: 50%;
                      overflow: hidden;
                      > img{
                        display: block;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                      }
                    }
                    > strong{
                      width: 0;
                      flex-grow: 1;
                      > span{
                        // width: 100%;
                        max-width: 0.8rem;
                        font-size: .12rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #666666;
                        line-height: 0.17rem;
                      }
                    }
                  }
                }
              }
              > dd {
                width: 100%;
                align-items: center;
                padding-bottom: 0.12rem;
                // justify-content: space-between;
                > h3{
                  width: 0;
                  flex-grow: 1;
                  margin-right: 0.04rem;
                  > strong{
                    width: 100%;
                    font-size: 0.12rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    line-height: 0.16rem;
                  }
                }
                > span{
                  flex-shrink: 0;
                  margin-right: 0.04rem;
                  font-size: 0.12rem;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #A5A5A5;
                  line-height: 0.16rem;
                  text-decoration:line-through;
                }
                > h4{
                  min-width: 0.48rem;
                  height: 0.16rem;
                  margin-right: 0.04rem;
                  flex-shrink: 0;
                  background: #FFEECC;
                  border-radius: 0.04rem;
                  > span{
                    font-size: 0.1rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #97762A;
                    line-height: 0.14rem;
                  }
                }
                > h2{
                  flex-shrink: 0;
                  > strong{
                    font-size: 0.16rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FF4C00;
                    line-height: 0.23rem;
                  }
                }
                > .is-vip-course-and-not-free{
                  > strong{
                    text-decoration: line-through;
                    color: #999999;
                  }
                }
              }
            }
            > .right-progress-course {
              width: 100%;
              height: 100%;
              justify-content: space-between;
              > dt {
                width: 100%;
                > .title-box {
                  width: 100%;
                  padding-top: 0.04rem;
                  padding-bottom: 0.15rem;
                  > strong {
                    width: 100%;
                    font-size: 0.15rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    line-height: 0.21rem;
                  }
                }
                > .learn-progress-bar {
                  flex-shrink: 0;
                  width: 100%;
                  > div{
                    width: 100%;
                    align-items: center;
                    > .progress-bar-container{
                      flex-shrink: 0;
                      width: 1rem;
                      height: 0.08rem;
                      margin-right: 0.1rem;
                      background: #EFEFEF;
                      > .progress-bar-content{
                        // min-width: 0;
                        // max-width: 100%;
                        width: 0%;
                        height: 100%;
                        background: linear-gradient(270deg, rgba(12, 224, 0, 0.25) 0%, #4BDC00 100%);
                      }
                    }
                    > h3{
                      > strong{
                        font-size: 0.12rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #666666;
                        line-height: 0.16rem;
                      }
                      > span{
                        font-size: 0.12rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #05BE00;
                        line-height: 0.16rem;
                      }
                    }
                  }
                }
              }
              > dd{
                width: 100%;
                padding-bottom: 0.15rem;
                > strong{
                  width: 100%;
                  font-size: 0.12rem;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #999999;
                  line-height: 0.16rem;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/course/new_course_info_comp.vue